<template>
  <div>
    <form>
      <v-container>
        <v-layout class="mb-4">
          <v-flex>
            <h2 class="mt-0">{{ $t('Delivery by distance') }}</h2>
            <span style="color:#000">{{ $t('1. Google API Key') }}</span>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has('googleapikey') }">
              <div style="display: flex;">
                <input
                  :data-vv-as="$t('Google API Key')"
                  v-validate="'required'"
                  v-model="googleapikey"
                  name="googleapikey"
                  class="form-control"
                  type="text"
                />
                <v-btn depressed color="primary" @click="insertGoogleMapScript">{{
                  $t('Success')
                }}</v-btn>
              </div>
              <span class="text-error" v-if="errors.has('googleapikey')">{{
                errors.first('googleapikey')
              }}</span>
            </div>
            <span style="color:#000">{{
              $t(
                "2. Specify the location of the shop/branch in the box. 'Enter Location' at the bottom of this Google Map window."
              )
            }}</span>
            <gmap-address
              class="mt-2"
              v-if="showmap"
              :placesinfo="placesinfolabel"
              v-validate="{ required: true }"
              name="ปักหมุดที่อยู่"
              v-model="gmapvalue"
              v-on:input="gmapLocation"
              :lastordercoords="gmapvalue"
              :error="errors.has('ปักหมุดที่อยู่')"
              :shoplocation="shoplocation"
            ></gmap-address>
            <div class="broadcasts mt-3 mb-3">
              <a href="javascript:void(0);" style="text-decoration: none" @click="addShoplocation">
                <div class="add-broadcast text-xs-center">
                  <i class="fa fa-plus middle mr-2"></i>
                  <span style="color:#000">{{ $t('3. Confirm the location') }}</span>
                </div>
              </a>
            </div>
            <span style="color:red" class="mr-2">*</span>
            {{
              $t(
                "To change Store/Branch Location Coordinates, please enter new location coordinates in the 'Fill Location' field at the bottom of the Google Map window and press the 'Change Location' button."
              )
            }}
            <template v-for="(item, i) in shoplocation">
              <v-card
                class="form-control mb-1"
                :class="{ 'has-error': errors.has('shopName') }"
                :key="i"
              >
                <v-card-text>
                  <v-layout>
                    <v-flex>
                      <label style="margin-top: 18px;">{{ $t('shopName') }}</label>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn outline small color="primary" @click="editShoplocation(item)">
                        เปลี่ยนพิกัดตำแหน่ง
                      </v-btn>
                      <v-btn small depressed color="primary" @click="deletedShop(i)">{{
                        $t('ลบร้านค้านี้')
                      }}</v-btn>
                    </v-flex>
                  </v-layout>
                  <input
                    :data-vv-as="$t('shopName')"
                    v-validate="'required'"
                    v-model="item.name"
                    name="shopName"
                    class="form-control"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('shopName')">{{
                    errors.first('shopName')
                  }}</span>
                </v-card-text>
              </v-card>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider />
      <template v-if="shoplocation && shoplocation.length > 0">
        <v-container>
          <h2 class="mt-0">{{ $t('Delivery terms') }}</h2>
          <v-layout wrap class="mb-4">
            <v-flex>
              <v-checkbox
                v-model="deliveryOption"
                label="จัดส่งตามที่อยู่"
                color="red"
                value="delivery"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="deliveryOption"
                label="จัดส่งโดยอิงจาก Google Map"
                color="red"
                value="map"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-if="$store.state.lalamove.includes(selectedBot.pageid)"
                v-model="deliveryOption"
                label="จัดส่งโดยอิงจาก Lalamove"
                color="red"
                value="lalamove"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="deliveryOption"
                label="รับสินค้าเองที่ร้าน"
                color="red"
                value="pickup"
                hide-details
              ></v-checkbox>

              <small style="color:red" v-if="deliveryOption && deliveryOption.length === 0">
                กรุณาเลือกตัวเลือกการรับสินค้า อย่างน้อย 1 แบบ
              </small>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider />
        <v-container v-if="deliveryOption && deliveryOption.includes('map')">
          <v-layout wrap class="mb-4">
            <v-flex>
              <h2 class="mt-0">{{ $t('Delivery terms') }}</h2>
              <span style="color:red" class="mr-2">*</span>
              {{ $t('Starting distance - Destination distance = Price (Baht)') }}
            </v-flex>
          </v-layout>
          <v-btn
            style="float: right; z-index: 1;"
            depressed
            color="primary"
            @click="deletedShop()"
            >{{ $t('Delete this store') }}</v-btn
          >
          <v-tabs class="tab-delivery" v-model="selectShoptab" slider-color="primary">
            <v-tab v-for="(shop, i) in shoplocation" :value="i" :key="i" ripple>
              {{ shop.name }}
            </v-tab>
            <v-tab-item v-for="(shop, i) in shoplocation" :key="i">
              <v-card flat>
                <v-layout
                  wrap
                  class="mb-4 mt-3"
                  v-for="(item, index) in shop.distance"
                  :key="'terms_' + index"
                >
                  <div style="display: flex;">
                    <div
                      class="form-control pa-1"
                      :class="{ 'has-error': errors.has(`startDistance${index}`) }"
                    >
                      <input
                        :disabled="index !== 0 ? true : false"
                        :data-vv-as="$t('Starting distance')"
                        v-validate="'required'"
                        v-model="item.startDistance"
                        :name="`startDistance${index}`"
                        class="form-control mr-3"
                        type="number"
                      />
                      <span class="text-error" v-if="errors.has(`startDistance${index}`)">{{
                        errors.first(`startDistance${index}`)
                      }}</span>
                    </div>
                    <!-- <div class="form-control">
              <input
                :disabled="index !== 0 ? true : false"
                type="number"
                pattern="[0-9]*"
                v-model="item.startDistance"
                inputmode="numeric"
                class="form-control mr-3"
              />
            </div> -->
                    <span class="ma-3"> <i class="fa fa-minus middle"></i> </span>
                    <div
                      class="form-control pa-1"
                      :class="{ 'has-error': errors.has(`endDistance${index}`) }"
                    >
                      <input
                        :data-vv-as="$t('Destination distance')"
                        v-validate="'required'"
                        v-model="item.endDistance"
                        :name="`endDistance${index}`"
                        class="form-control mr-3"
                        type="number"
                        @change="changeEndDistance(item.endDistance, index)"
                      />
                      <span class="text-error" v-if="errors.has(`endDistance${index}`)">{{
                        errors.first(`endDistance${index}`)
                      }}</span>
                    </div>
                    <!-- <div class="form-control">
              <input
                type="number"
                pattern="[0-9]*"
                v-model="item.endDistance"
                inputmode="numeric"
                class="form-control mr-3"
                @change="
                  item.endDistance !== null &&
                  item.endDistance !== '' &&
                  JSON.parse(item.endDistance) > JSON.parse(item.startDistance)
                    ? (errorText = false)
                    : (errorText = true)
                "
              />
            </div> -->
                    <span class="ma-3"> <i class="fas fa-equals middle"></i> </span>
                    <div
                      class="form-control pa-1"
                      :class="{ 'has-error': errors.has(`price${index}`) }"
                    >
                      <input
                        :data-vv-as="$t('ราคา')"
                        v-validate="'required'"
                        v-model="item.price"
                        :name="`price${index}`"
                        class="form-control mr-3"
                        type="number"
                      />
                      <span class="text-error" v-if="errors.has(`price${index}`)">{{
                        errors.first(`price${index}`)
                      }}</span>
                    </div>
                    <!-- <div class="form-control">
              <input
                type="number"
                pattern="[0-9]*"
                v-model="item.price"
                inputmode="numeric"
                class="form-control mr-3"
              />
            </div> -->
                    <span class="mt-3 ml-3"> {{ $t('Baht') }}</span>
                    <a
                      href="javascript:void(0);"
                      v-if="index !== 0"
                      class="ml-5 mt-3"
                      @click="deleteTermsDelivery(item, i)"
                    >
                      <i class="fas fa-trash"></i
                    ></a>
                    <span v-else class="ml-5 mt-3"> <i class="fas fa-trash"></i></span>
                  </div>
                </v-layout>
                <small style="color:red" v-if="errorText">
                  {{
                    $t(
                      'Please increase the destination distance before adding shipping conditions and The destination distance must be greater than the origin.'
                    )
                  }}
                </small>
                <div class="broadcasts">
                  <a
                    href="javascript:void(0);"
                    style="text-decoration: none"
                    @click="addTermsDelivery(shop)"
                  >
                    <div class="add-broadcast text-xs-center">
                      <i class="fa fa-plus middle"></i>
                      {{ $t('Add delivery terms') }}
                    </div>
                  </a>
                </div>
              </v-card>
              <v-layout wrap class="mb-4" style="display: block;">
                <div class="mt-4 primary--text">{{ $t('If the distance from above') }}</div>
                <v-radio-group
                  v-model="shop.termsOption"
                  color="primary"
                  col
                  class="text-xs-center"
                >
                  <v-radio color="primary" :value="'none'">
                    <template slot="label">
                      <span> {{ $t('Not delivery') }}</span>
                    </template>
                  </v-radio>
                  <v-radio color="primary" :value="'type1'">
                    <template slot="label">
                      <div class="form-control" style="display: flow-root;">
                        <span class="mt-2"> {{ $t('Add each kilometer') }}</span>
                        <input
                          type="number"
                          :disabled="shop.termsOption !== 'type1'"
                          v-model="shop.optionType1[0]"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          class="form-control ml-2 mr-2"
                          style="width: 90px;"
                        />
                        <span class="mt-2"> {{ $t('Baht, but must not exceed') }}</span>
                        <input
                          type="number"
                          :disabled="shop.termsOption !== 'type1'"
                          v-model="shop.optionType1[1]"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          class="form-control ml-2 mr-2"
                          style="width: 90px;"
                        />
                        <span class="mt-2"> {{ $t('kilometer') }}</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-radio color="primary" :value="'type2'">
                    <template slot="label">
                      <div class="form-control" style="display: flow-root;">
                        <span class="mt-2"> {{ $t('Charge a contract price') }}</span>
                        <input
                          type="number"
                          :disabled="shop.termsOption !== 'type2'"
                          v-model="shop.optionType2[0]"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          class="form-control ml-2 mr-2"
                          style="width: 90px;"
                        /><span class="mt-2"> {{ $t('Baht, but must not exceed') }}</span>
                        <input
                          type="number"
                          :disabled="shop.termsOption !== 'type2'"
                          v-model="shop.optionType2[1]"
                          pattern="[0-9]*"
                          inputmode="numeric"
                          class="form-control ml-2 mr-2"
                          style="width: 90px;"
                        />
                        <span class="mt-2"> {{ $t('kilometer') }}</span>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <small style="color:red" v-if="errorCheckType">
                  {{ $t('Please fill in the distance completely.') }}
                </small>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-container>
        <template v-if="deliveryOption && deliveryOption.includes('lalamove')">
          <v-divider />
          <v-container>
            <h2 class="mt-0">{{ $t('เงื่อนไขการจัดส่งด้วย Lalamove') }}</h2>
            <div class="form-control">
              <div>Status</div>
              <toggle-button
                class="mb-3 mt-2"
                :value="lalamove.status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="toggleStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
              <div>Api Key</div>
              <input
                type="text"
                v-model="lalamove.api_key"
                name="api_key"
                data-vv-as="Api Key"
                v-validate="'required'"
              />
              <small style="color:red" v-if="errors.has('api_key')">
                {{ errors.first('api_key') }}
              </small>
              <div>Api Secret</div>
              <input
                type="text"
                v-model="lalamove.api_secret"
                name="api_secret"
                data-vv-as="Api Secret"
                v-validate="'required'"
              />
              <small style="color:red" v-if="errors.has('api_secret')">
                {{ errors.first('api_secret') }}
              </small>
            </div>

            <div class="mt-4 primary--text">ค่าส่งที่เพิ่มเติมจาก Lalamove</div>
            <template v-for="(item, i) in shoplocation">
              <v-card
                class="form-control mb-1"
                :class="{ 'has-error': errors.has('shopLalamoveFee') }"
                :key="i"
              >
                <v-card-text>
                  <label style="margin-top: 18px;"
                    >{{ $t('ค่าส่งเพิ่มเติมของร้าน') }} {{ item.name }}</label
                  >
                  <input
                    :data-vv-as="$t('ค่าส่งเพิ่มเติม')"
                    v-validate="'required'"
                    v-model="item.lalamoveFee"
                    name="shopLalamoveFee"
                    class="form-control"
                    type="number"
                    min="0"
                    max="1000"
                    @keypress="isNumber($event, item.lalamoveFee)"
                  />
                  <span class="text-error" v-if="errors.has('shopLalamoveFee')">{{
                    errors.first('shopLalamoveFee')
                  }}</span>
                </v-card-text>
              </v-card>
            </template>
          </v-container>
        </template>
        <v-container class="text-xs-center">
          <v-btn depressed color="primary" @click="checkTypeSubmit">{{ $t('Save') }}</v-btn>
        </v-container>
      </template>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import GmapAddress from '@/components/elements/GmapAddress.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      deliveryOption: ['delivery'],
      errorText: false,
      // shopName: null,
      // termsOption: 'none',
      // optionType1: [],
      // optionType2: [],
      googleapikey: null,
      termsDelivery: [{}],
      // shippingcostdistance: null,
      gmapvalue: null,
      showmap: false,
      placesinfolabel: null,
      errorCheckType: false,
      shoplocation: [],
      selectShoptab: 0,
      lalamove: {
        status: false,
        api_key: '',
        api_secret: ''
      }
    }
  },
  components: { GmapAddress, ToggleButton },
  async mounted() {
    if (this.selectedBot && this.selectedBot.lalamove_info)
      this.lalamove = this.selectedBot.lalamove_info
    try {
      let item = await this.getShippingcostdistance()
      if (item) {
        if (typeof item.shippingcostdistance.shoplocation === 'undefined') {
          item.shippingcostdistance.shoplocation = [
            {
              name: item.shippingcostdistance[0].shopName,
              lat_long: `${item.shippingcostdistance[0].gmapvalue.lat}, ${
                item.shippingcostdistance[0].gmapvalue.lng
              }`,
              pictureurl: null,
              distance: item.shippingcostdistance[0].distance,
              optionType1: item.shippingcostdistance[0].optionType1,
              optionType2: item.shippingcostdistance[0].optionType2,
              termsOption: item.shippingcostdistance[0].termsOption,
              id: new Date()
            }
          ]

          item.shippingcostdistance.deliveryOption = item.shippingcostdistance[0].deliveryOption
        }
        // if (item.shippingcostdistance) {
        //   console.log(item.shippingcostdistance)
        //   this.shippingcostdistance = item.shippingcostdistance
        this.termsDelivery = item.shippingcostdistance.shoplocation[this.selectShoptab].distance
        this.deliveryOption = item.shippingcostdistance.deliveryOption
        // } else {
        //   this.termsDelivery = [
        //     {
        //       startDistance: null,
        //       endDistance: null,
        //       price: null
        //     }
        //   ]
        // }
        this.googleapikey = item.googleapikey
        // this.optionType1 = this.shippingcostdistance[0].optionType1
        // this.optionType2 = this.shippingcostdistance[0].optionType2
        // this.termsOption = this.shippingcostdistance[0].termsOption
        // this.shoplocation = this.shippingcostdistance[0].shoplocation
        this.shoplocation = item.shippingcostdistance.shoplocation
        // this.gmapvalue = this.shippingcostdistance.shoplocation[0].gmapvalue
        // if (this.gmapvalue) {
        this.insertGoogleMapScript()
        // }
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    toggleStatus(val) {
      this.$set(this.lalamove, 'status', val.value)
    },
    changeEndDistance(endDistance, index) {
      endDistance !== null &&
      endDistance !== '' &&
      JSON.parse(endDistance) > JSON.parse(this.termsDelivery[index].startDistance)
        ? (this.errorText = false)
        : (this.errorText = true)
      if (typeof this.termsDelivery[index + 1] !== 'undefined') {
        this.termsDelivery[index + 1].startDistance =
          JSON.parse(this.termsDelivery[index].endDistance) + 0.01
      }
    },

    gmapLocation() {
      var vm = this
      var stringlatlng = this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      var service = new google.maps.DistanceMatrixService()
      var origins = [stringlatlng]

      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH'
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          vm.placesinfolabel = response.destinationAddresses[0]
        }
      }
    },
    insertGoogleMapScript() {
      var vm = this
      vm.showmap = false
      let externalScript = document.createElement('script')
      externalScript.setAttribute(
        'src',
        `https://maps.googleapis.com/maps/api/js?key=${
          vm.googleapikey
        }&language=th&libraries=places`
      )
      externalScript.async = true
      externalScript.defer = true
      externalScript.onload = () => {
        vm.showmap = true
      }
      document.head.appendChild(externalScript)
    },
    getShippingcostdistance() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getShippingcostdistance(
          {
            pageid: vm.selectedBot.pageid
          },
          (err, response) => {
            if (err) {
              reject(err)
            }
            resolve(response)
          }
        )
      })
    },

    async checkTypeSubmit() {
      let result = await this.$validator.validateAll()
      if (result) {
        if (this.termsOption === 'type1') {
          if (this.optionType1[0] !== '' && this.optionType1[1] !== '') {
            this.submit()
          } else {
            this.errorCheckType = true
          }
        } else if (this.termsOption === 'type2') {
          if (this.optionType2[0] !== '' && this.optionType2[1] !== '') {
            this.submit()
          } else {
            this.errorCheckType = true
          }
        } else {
          this.submit()
        }
      }
    },
    async submit() {
      if (this.googleapikey && !this.errorText && this.deliveryOption.length !== 0) {
        if (!this.shippingcostdistance) {
          this.postAndPutShippingcostdistance('post').then(item => {
            this.errorCheckType = false
            this.$store.dispatch('loading')
            this.$swal({
              title: 'สำเร็จ',
              type: 'success',
              text: `ข้อมูลของท่านทำการบันทึกเรียบร้อยแล้ว`,
              confirmButtonText: this.$t('Confirm')
            })
          })
        } else {
          this.postAndPutShippingcostdistance('put').then(item => {
            this.$store.dispatch('loading')
            this.$swal({
              title: 'สำเร็จ',
              type: 'success',
              text: `ข้อมูลของท่านทำการบันทึกเรียบร้อยแล้ว`,
              confirmButtonText: this.$t('Confirm')
            })
          })
        }
      }

      if (this.deliveryOption && this.deliveryOption.includes('lalamove')) {
        let data = cloneDeep(this.lalamove)
        data.status = data.status == true || data.status == 'true' ? data.status : false
        const allowed = ['status', 'api_key', 'api_secret']

        const filtered = Object.keys(data)
          .filter(key => allowed.includes(key))
          .reduce((obj, key) => {
            obj[key] = data[key]
            return obj
          }, {})
        let response = await this.post(
          `lalamove/${this.selectedBot.pageid}/save-config`,
          filtered,
          {}
        )
        await this.$store.dispatch('updateBotDetail')
      }
    },
    postAndPutShippingcostdistance(type) {
      this.$store.dispatch('loading')
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          params: { pageid: vm.selectedBot.pageid },
          body: {
            shippingcostdistance: JSON.stringify({
              shoplocation: vm.shoplocation,
              deliveryOption: vm.deliveryOption
            }),
            googleapikey: vm.googleapikey
          }
        }
        if (type === 'post') {
          api.postShippingcostdistance(data, function(error, response) {
            if (error) {
              vm.$swal.fire({
                type: 'error',
                text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
              })
              reject(error)
            }
            resolve(response)
          })
        } else {
          api.putShippingcostdistance(data, function(error, response) {
            if (error) {
              vm.$swal.fire({
                type: 'error',
                text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
              })
              reject(error)
            }
            resolve(response)
          })
        }
      })
    },
    deleteTermsDelivery(terms, index) {
      this.shoplocation[index].distance = this.shoplocation[index].distance.filter(
        item => item !== terms
      )
    },
    addTermsDelivery(shop) {
      this.termsDelivery = shop.distance
      var startDistance = this.termsDelivery[this.termsDelivery.length - 1].startDistance
      var endDistance = this.termsDelivery[this.termsDelivery.length - 1].endDistance
      if (
        endDistance !== null &&
        endDistance !== '' &&
        JSON.parse(endDistance) > JSON.parse(startDistance)
      ) {
        this.termsDelivery.push({
          startDistance: endDistance ? JSON.stringify(JSON.parse(endDistance) + 0.01) : null,
          endDistance: null,
          price: null
        })
        this.errorText = false
      } else {
        this.errorText = true
      }
    },

    editShoplocation(shoplocation) {
      shoplocation.lat_long = this.gmapvalue.lat + ',' + this.gmapvalue.lng
      this.insertGoogleMapScript()
    },
    async addShoplocation() {
      let result = await this.$validator.validateAll()
      if (result && this.gmapvalue) {
        this.shoplocation.push({
          name: 'shop' + (this.shoplocation.length + 1),
          lat_long: this.gmapvalue.lat + ',' + this.gmapvalue.lng,
          pictureurl: null,
          distance: [{}],
          optionType1: [],
          optionType2: [],
          termsOption: 'none',
          id: Date.now()
        })
        this.insertGoogleMapScript()
      }
    },
    async deletedShop(i = null) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let delete_index = i ? i : this.selectShoptab
        this.shoplocation = this.shoplocation.filter((item, index) => index !== delete_index)
        this.insertGoogleMapScript()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Delivery.vue